import React from 'react';
import ReactGA from 'react-ga';

import image from './mistra.png';

export default () => (
  <div className="Research">
    <div className="title">
      Research
    </div>
    <div className="content">
      Check out my <a href="#publications">publications</a>, <a href="#research-participations">research participations</a> and <a href="#conference-participations">conference participations</a>.
    </div>
    <div id="publications" className="subtitle">
      Publications
    </div>
    <div className="small-title">
      Peer reviewed joined articles
    </div>
    <div className="content">
      Kural, E., Dellmuth, L.M., Gustafsson, M.-T.,&nbsp;
      <ReactGA.OutboundLink
        eventLabel="International organizations and climate change adaptation"
        to="https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0257101"
        target="_blank"
      >
        “International organizations and climate change adaptation: A newdataset for the social
        scientific study of adaptation, 1990–2017”
      </ReactGA.OutboundLink>
      &nbsp;, PLOS ONE, 16(9): e0257101.
      <ul className="sub-content">
        <li>
          <ReactGA.OutboundLink
            eventLabel="Replication material for International organizations and climate change adaptation"
            to="https://dataverse.harvard.edu/dataset.xhtml?persistentId=doi:10.7910/DVN/46BWAZ"
            target="_blank"
          >
            Replication material
          </ReactGA.OutboundLink>
        </li>
        <li>
          <ReactGA.OutboundLink
            eventLabel="Press Release for International organizations and climate change adaptation"
            to="https://www.mistra-geopolitics.se/news/increased-engagement-in-climate-adaptation/"
            target="_blank"
          >
            Read the press release
          </ReactGA.OutboundLink>
        </li>
      </ul>
    </div>
    <div className="content">
      Kural, E., Dellmuth, L.M., Gustafsson, M.-T.,&nbsp;
      <ReactGA.OutboundLink
        eventLabel="Global adaptation governance"
        to="https://www.sciencedirect.com/science/article/pii/S1462901120303907"
        target="_blank"
      >
        “Global adaptation governance: Explaining the governance responses of international
        organizations to new issue linkages”
      </ReactGA.OutboundLink>
      &nbsp;, Environmental Science &amp; Policy, 114 (2020), pp. 204-215.
    </div>
    <div className="small-title">
      Dissertations
    </div>
    <div className="content">
      Kural, E.,&nbsp;
      <ReactGA.OutboundLink
        eventLabel="Global Adaptation Governance: Evidence from 30 International Organizations, 1990-2017"
        to="https://www.diva-portal.org/smash/record.jsf?pid=diva2%3A1582782&dswid=8360"
        target="_blank"
      >
        “Global Adaptation Governance: Evidence from 30 International Organizations, 1990-2017”
      </ReactGA.OutboundLink>
      &nbsp;, Stockholm Studies in International Relations, ISSN 2003-1343 ; 2021:1.
    </div>
    <div className="content">
      Kural, E.,&nbsp;
      <ReactGA.OutboundLink
        eventLabel="Consolidation of Power and Media: A Study on News Frames of PKK Attacks in Turkey"
        to="https://www.diva-portal.org/smash/record.jsf?pid=diva2%3A1082874&dswid=-4832"
        target="_blank"
      >
        “Consolidation of Power and Media: A Study on News Frames of PKK Attacks in Turkey”
      </ReactGA.OutboundLink>
      &nbsp;, Uppsala University, 2017.
    </div>
    <div id="research-participations" className="subtitle">
      Research Participations
    </div>
    <div className="content">
      Mistra Geopolitics Project (2017-2020) Sustainable development in a changing geo-political
      era: Challenges and opportunities for Sweden.
    </div>
    <div className="content">
      Read the policy brief I co-authored within the Mistra Geopolitics project:&nbsp;
      <ReactGA.OutboundLink
        eventLabel=""
        to="https://www.mistra-geopolitics.se/wp-content/uploads/2021/05/Policy_brief_International_organizations_and_adaptation_governance_2021.pdf"
        target="_blank"
      >
        “International organizations and adaptation governance: Lessons for policymaking”
      </ReactGA.OutboundLink>
      .
    </div>
    <div className="content">
      I conducted my research within the work package on “Governance responses to climate
      related security risks” at Stockholm University, which seeked to understand global governance
      responses to climate security challenges. My research was funded by the Swedish Foundation for
      Strategic Environmental Research (Mistra), and Stockholm University.
    </div>
    <div style={{ textAlign: 'center', width: '100%', marginBottom: '14px' }}>
      <img src={image} alt="Mistra Geopolitics Project Logo" style={{ maxWidth: '100%' }} />
    </div>
    <div className="content">
      Mistra Geopolitics program brings together six Swedish core partners: the Stockholm
      Environment Institute (SEI), the Stockholm International Peace Research Institute (SIPRI),
      and the universities of Linköping, Lund, Stockholm, and Uppsala. The overarching aim is to
      provide a deepening understanding on how our society needs to be reformed in order to address
      increasing resource scarcity while securing a positive development and political stability in
      the 21st Century - an epoch referred to as the “Anthropocene”.
    </div>
    <div id="conference-participations" className="subtitle">
      Conference Participation &amp; Presentations
    </div>
    <div className="content">
      “Capacity and Collaboration in Global Adaptation Governance.” with Lisa-Maria Dellmuth and
      Maria-Therese Gustafsson, presented at Earth Systems Governance (ESG) Conference, Oaxaca,
      5-7 November 2019.
    </div>
    <div className="content">
      “How International Organizations Engage with Climate Change Adaptation: The Case of
      Non- Climate IOs.” presented at Earth Systems Governance (ESG) Conference, Oaxaca,
      5-7 November 2019.
    </div>
    <div className="content">
      “Institutional fragmentation, problem complexity, and international organizations’ strategies
      to address climate risks.” with Lisa-Maria Dellmuth and Maria-Therese Gustafsson, presented at
      International Studies Association (ISA) 60th Annual Convention Toronto, 27-30 March 2019.
    </div>
    <div className="content">
      “How International Organizations Engage with Climate Change Adaptation: The Case of
      Non- Environmental IOs.” presented at International Studies Association (ISA) 60th Annual
      Convention Toronto, 27-30 March 2019.
    </div>
    <div className="content">
      “Integrated Global Governance on Climate Security.” presented at ECPR General
      Conference Hamburg, 22-25 August 2018.
    </div>
    <div className="content">
      “Institutional Integration in Global Climate Risks Governance.” presented at
      4th Annual Conference on International Studies in the 21st Century, Stockholm
      11-12 June, 2018.
    </div>
    <div className="content">
      “Global Climate Risks Governance.” presented at Nordic Climate Governance Workshop,
      Copenhagen, 13-15 May 2018.
    </div>
    <div className="content">
      “Democracy, Media and Public Outcry: The Impact of News Media Coverage on EU Member States’
      Policy-Making in the Current Refugee-Crisis in Europe” With Augustinus Mohn. Presented at
      24th World Congress of Political Science, International Political Science Association, July
      2016.
    </div>
    <div className="content">
      “Terrorism and Accountability: Mitigating Role of Local Politics.” With Resat Bayer and Ozge
      Kemahlioglu. Presented at 5th Annual General Conference of the European Political Science
      Association, Vienna, Austria, June 2015.
    </div>
    <div className="content">
      “Violence and the Electorate: ETA and Basques.” Presented at the International Association
      for Political Science Students World Congress, London, UK, April 2015.
    </div>
    <div className="content">
      “Violence at Your Footstep: Incumbency, Political Parties and Terrorism.” With Resat Bayer
      and Ozge Kemahlioglu. Presented at FLACSO-ISA Joint International Conference, Buenos Aires,
      Argentina, July 2014. Also presented at the International Association for Political Science
      Students World Congress, London, UK, April 2015.
    </div>
    <div className="content">
      “Pairing Effect Matters: Decision Making among Different Outgroups.” Presented at National
      Psychology Students Conference, Samsun, Turkey, June 2014.
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/research/View.js